/* Vesper Cocktails redesign: motion runtime.
   Faithful port of vc-motion.js from the Claude Design project (same
   attributes, classes, timings and safety nets). Shopify additions:
   - window.VCMotion = { scan, revealAll, reveal } for page code;
   - re-scan on theme-editor section load/reorder (the MutationObserver
     already catches new nodes; the events make it explicit);
   - on section/block select in the editor, reveal that section's
     content immediately so merchants never edit invisible blocks.
   Load synchronously in <head> (as the mockups do) so html.vc-motion is
   set before first paint. */
(function () {
  if (window.__vcMotion) return; window.__vcMotion = 1;
  var E = 'cubic-bezier(0.22,0.61,0.36,1)';
  var st = document.createElement('style');
  st.textContent =
    '@keyframes vcRise{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}' +
    '@keyframes vcMarquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}' +
    '@keyframes vcSpin{to{transform:rotate(360deg)}}' +
    'html.vc-motion [data-reveal]:not(.vc-in),html.vc-motion [data-stagger]>:not(.vc-in){opacity:0}' +
    'html.vc-motion .vc-in{animation:vcRise 560ms ' + E + ' backwards;animation-delay:var(--vc-d,0ms)}' +
    '@media (prefers-reduced-motion:reduce){html.vc-motion [data-reveal]:not(.vc-in),html.vc-motion [data-stagger]>:not(.vc-in){opacity:1}html.vc-motion .vc-in{animation:none}}';
  document.head.appendChild(st);
  var root = document.documentElement;
  var hasIO = 'IntersectionObserver' in window;
  // Only hide content when the page is visible and the observer can actually reveal it.
  if (hasIO && !document.hidden) root.classList.add('vc-motion');
  var watched = [];
  function show(el) { el.classList.add('vc-in'); }
  var io = hasIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }) : null;
  function inView(el) { var r = el.getBoundingClientRect(); return r.top < (window.innerHeight || 800) && r.bottom > 0; }
  function watch(el, d) {
    el.setAttribute('data-vc-seen', '');
    if (d) el.style.setProperty('--vc-d', d + 'ms');
    if (!root.classList.contains('vc-motion') || !io || inView(el)) { show(el); return; }
    watched.push(el); io.observe(el);
  }
  function scan() {
    document.querySelectorAll('[data-reveal]:not([data-vc-seen])').forEach(function (el) { watch(el, el.getAttribute('data-reveal')); });
    document.querySelectorAll('[data-stagger]').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) { if (!c.hasAttribute('data-vc-seen')) watch(c, (i % 4) * 90); });
    });
  }
  function revealAll() { watched.forEach(show); document.querySelectorAll('[data-reveal],[data-stagger]>*').forEach(show); }
  function reveal(scope) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches('[data-reveal],[data-stagger]>*')) show(scope);
    scope.querySelectorAll('[data-reveal],[data-stagger]>*').forEach(function (el) { show(el); if (io) io.unobserve(el); });
  }
  var q = false;
  new MutationObserver(function () { if (!q) { q = true; setTimeout(function () { q = false; scan(); }, 0); } })
    .observe(root, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  document.addEventListener('visibilitychange', function () { if (document.hidden) revealAll(); });
  window.addEventListener('beforeprint', function () { root.classList.remove('vc-motion'); revealAll(); });
  // Safety net: if the page is hidden/headless, never leave content invisible.
  setTimeout(function () { if (document.hidden) { root.classList.remove('vc-motion'); revealAll(); } }, 1500);

  // Shopify theme editor
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:reorder', scan);
  document.addEventListener('shopify:section:select', function (e) { reveal(e.target); });
  document.addEventListener('shopify:block:select', function (e) { reveal(e.target); });

  window.VCMotion = { scan: scan, revealAll: revealAll, reveal: reveal };
  scan();
})();
